import { createContext, useContext, useState } from 'react';

const EditStatusContext = createContext();

export const HasEditedStatusProvider = ({ children }) => {
  const [hasEdited, setHasEdited] = useState(false);

  return (
    <EditStatusContext.Provider value={{ hasEdited, setHasEdited }}>
      {children}
    </EditStatusContext.Provider>
  );
};

export const useHasEditedStatus = () => {
  const context = useContext(EditStatusContext);
  if (!context) {
    throw new Error(
      'useEditStatus must be used within an HasEditStatusProvider'
    );
  }
  return context;
};
